

function Jobs(props) {
  return 'Jobs'
}
export default Jobs;